import request from '@/utils/request'

// 查询菜单列表
export function listMenu(data) {
  return request({
    url: '/SystemBase/WebMenu/Search',
    method: 'post',
    data: data
  })
}

// 添加菜单
export function WebMenuAdd(data) {
  return request({
    url: '/SystemBase/WebMenu/WebMenuAdd',
    method: 'post',
    data: data
  })
}

// 修改菜单
export function WebMenuUpdate(data) {
  return request({
    url: '/SystemBase/WebMenu/WebMenuUpdate',
    method: 'post',
    data: data
  })
}

// 删除菜单
export function DeptDelete(menuId) {
  return request({
    url: '/SystemBase/WebMenu/DeptDelete?id=' + menuId,
    method: 'post'
  })
}


// 当前用户菜单
export function CurrentMenu() {
  return request({
    url: '/SystemBase/WebMenu/CurrentMenu',
    method: 'post'
  })
  // return {"menu_list": [{
	// 			"id": 5,
	// 			"wm_parent_id": 0,
	// 			"wm_name": "系统管理",
	// 			"wm_url": "/system",
	// 			"wm_module_id": 11430001,
	// 			"wm_order": 0,
	// 			"wm_status": 1,
	// 			"children": [{
	// 					"id": 6,
	// 					"wm_parent_id": 5,
	// 					"wm_name": "员工管理",
	// 					"wm_url": "/system/user",
	// 					"wm_module_id": 11430004,
	// 					"wm_order": 1.0000000000000000000000000000,
	// 					"wm_status": 1,
	// 					"children": []
	// 				},
	// 				{
	// 					"id": 7,
	// 					"wm_parent_id": 5,
	// 					"wm_name": "角色管理",
	// 					"wm_url": "/system/role",
	// 					"wm_module_id": 11430005,
	// 					"wm_order": 2.0000000000000000000000000000,
	// 					"wm_status": 1,
	// 					"children": []
	// 				},
	// 				{
	// 					"id": 8,
	// 					"wm_parent_id": 5,
	// 					"wm_name": "菜单管理",
	// 					"wm_url": "/system/menu",
	// 					"wm_module_id": 11430006,
	// 					"wm_order": 3.0000000000000000000000000000,
	// 					"wm_status": 1,
	// 					"children": []
	// 				},
	// 				{
	// 					"id": 9,
	// 					"wm_parent_id": 5,
	// 					"wm_name": "部门管理",
	// 					"wm_url": "/system/dept",
	// 					"wm_module_id": 11430007,
	// 					"wm_order": 4.0000000000000000000000000000,
	// 					"wm_status": 1,
	// 					"children": []
	// 				},
	// 				{
	// 					"id": 10,
	// 					"wm_parent_id": 5,
	// 					"wm_name": "模块管理",
	// 					"wm_url": "/system/modules",
	// 					"wm_module_id": 11430008,
	// 					"wm_order": 5.0000000000000000000000000000,
	// 					"wm_status": 1,
	// 					"children": []
	// 				},
	// 				{
	// 					"id": 11,
	// 					"wm_parent_id": 5,
	// 					"wm_name": "字典管理",
	// 					"wm_url": "/system/dictType",
	// 					"wm_module_id": 11430010,
	// 					"wm_order": 6.0000000000000000000000000000,
	// 					"wm_status": 1,
	// 					"children": []
	// 				},
				
	// 			]
	// 		}
		
	// 	],
	// 	"button_list": [{
	// 			"id": 11430030,
	// 			"m_name": "浏览",
	// 			"m_desc": "",
	// 			"parent_id": 11430004,
	// 			"level_id": "11430001_11430004_11430030",
	// 			"m_button": 1,
	// 			"order_by": 0.0000000000000000000000000000,
	// 			"children": null
	// 		},
	// 		{
	// 			"id": 11430031,
	// 			"m_name": "编辑",
	// 			"m_desc": "",
	// 			"parent_id": 11430004,
	// 			"level_id": "11430001_11430004_11430031",
	// 			"m_button": 1,
	// 			"order_by": 0.0000000000000000000000000000,
	// 			"children": null
	// 		},
	// 		{
	// 			"id": 11430009,
	// 			"m_name": "添加",
	// 			"m_desc": "system:role:add",
	// 			"parent_id": 11430005,
	// 			"level_id": "11430001_11430005_11430009",
	// 			"m_button": 1,
	// 			"order_by": 0.0000000000000000000000000000,
	// 			"children": null
	// 		},
	// 		{
	// 			"id": 11430041,
	// 			"m_name": "修改",
	// 			"m_desc": "unsafeBehavior:edit",
	// 			"parent_id": 11430018,
	// 			"level_id": "11430018_11430041",
	// 			"m_button": 1,
	// 			"order_by": 0.0000000000000000000000000000,
	// 			"children": null
	// 		},
	// 		{
	// 			"id": 11430042,
	// 			"m_name": "删除",
	// 			"m_desc": "unsafeBehavior:delete",
	// 			"parent_id": 11430018,
	// 			"level_id": "11430018_11430042",
	// 			"m_button": 1,
	// 			"order_by": 0.0000000000000000000000000000,
	// 			"children": null
	// 		},
	// 		{
	// 			"id": 11430043,
	// 			"m_name": "罚单",
	// 			"m_desc": "unsafeBehavior:violation_ticket",
	// 			"parent_id": 11430018,
	// 			"level_id": "11430018_11430043",
	// 			"m_button": 1,
	// 			"order_by": 0.0000000000000000000000000000,
	// 			"children": null
	// 		},
	// 		{
	// 			"id": 11430047,
	// 			"m_name": "解码",
	// 			"m_desc": "safeCodeding:decode",
	// 			"parent_id": 11430021,
	// 			"level_id": "11430012_11430021_11430047",
	// 			"m_button": 1,
	// 			"order_by": 0.0000000000000000000000000000,
	// 			"children": null
	// 		},
	// 		{
	// 			"id": 11430048,
	// 			"m_name": "赋码",
	// 			"m_desc": "safeCodeding:coding",
	// 			"parent_id": 11430021,
	// 			"level_id": "11430012_11430021_11430048",
	// 			"m_button": 1,
	// 			"order_by": 0.0000000000000000000000000000,
	// 			"children": null
	// 		}
	// 	]
	// };
}
		
